import React, { useEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { Title, Modal } from '@common/components';
import { popIn } from '@common/utils/services';
import ThemeForm from '../Form';
import { fetchTheme, updateTheme } from '@resources/Theme/actions';
import { useIntl } from 'react-intl';
import isEmpty from 'lodash.isempty';

const Update = (props) => {
	const { module, fetchTheme, theme, updateTheme, visible, onCancel } = props;
	const intl = useIntl();

	useEffect(() => {
		const fetchData = async () => {
			await fetchTheme(visible);
		};
		visible && fetchData();
	}, [fetchTheme, visible]);

	const handleSubmit = useCallback(
		(data) => {
			return updateTheme(theme._id, data)
				.then((response) => {
					popIn(
						'success',
						intl.formatMessage({
							id: 'message.success.theme.update',
							defaultMessage:
								'An existing Theme entry has been successfully updated',
						})
					);

					onCancel && onCancel();
				})
				.catch((err) => Promise.reject(err));
		},
		[theme]
	);

	return (
		<Modal visible={visible} onCancel={() => onCancel()}>
			<Title>
				{intl.formatMessage({
					id: 'common.update.theme',
					defaultMessage: 'Update Theme',
				})}
			</Title>
			{!isEmpty(theme) && visible && (
				<ThemeForm
					data={theme}
					onSubmit={handleSubmit}
					{...props}
					module={module}
				/>
			)}
		</Modal>
	);
};

const mapStateToProps = ({
	theme,
	modules,
	cellGroup,
	event,
	facility,
	ministry,
	mission,
	organization,
	prayer,
	testimony,
}) => {
	return {
		theme,
		modules,
		cellGroup,
		event,
		facility,
		ministry,
		mission,
		organization,
		prayer,
		testimony,
	};
};

export default connect(mapStateToProps, {
	fetchTheme,
	updateTheme,
})(Update);
